import React, { useState } from 'react';
import { login } from '../auth';
import './Login.css';

export default function Login({ onLogin }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await login(username.trim(), password);
            setLoading(false);
            onLogin();
        } catch (err) {
            setLoading(false);
            setError(err.message || '登录失败');
        }
    };

    return (
        <div className="login-wrap">
            <form className="login-box" onSubmit={handleSubmit}>
                <h1 className="login-title">单词学习</h1>
                <p className="login-sub">请登录后使用</p>
                <label className="login-label">用户名</label>
                <input
                    className="login-input"
                    type="text"
                    value={username}
                    autoFocus
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="用户名"
                />
                <label className="login-label">密码</label>
                <input
                    className="login-input"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="密码"
                />
                {error && <div className="login-error">{error}</div>}
                <button className="login-btn" type="submit" disabled={loading}>
                    {loading ? '登录中…' : '登录'}
                </button>
            </form>
        </div>
    );
}
